module.exports = __webpack_public_path__ + "img/记录边框.d77b6ce1.png";